// assets
import { TeamOutlined } from '@ant-design/icons';

const icons = {
  TeamOutlined
};

const admin = {
  id: 'group-workspace',
  title: 'Workspace',
  type: 'group',
  children: [
    {
      id: 'team',
      title: 'Team',
      type: 'item',
      url: '/team',
      icon: icons.TeamOutlined
    }
  ]
};

export default admin;
